export default {};

export const UNIT_OPTIONS = [
  {
    label: 'KM',
    value: 'km',
  },
  {
    label: 'Miles',
    value: 'mi',
  },
];
export const MI_TO_KM = 1.60934;
export const PROPERTY_MAP = {
  mileage: {
    thresholdEmailProperty: 'thresholdMileageEmailSent',
    thresholdProperty: 'thresholdMileage',
    nearThresholdProperty: 'nearThresholdMileage',
    currentProperty: 'currentMileage',
    totalLifetimeProperty: 'totalLifetimeMileage',
    title: 'Mileage',
  },
  hours: {
    thresholdEmailProperty: 'thresholdEmailSent',
    thresholdProperty: 'thresholdHours',
    nearThresholdProperty: 'nearThresholdHours',
    currentProperty: 'currentHours',
    totalLifetimeProperty: 'totalLifetimeHours',
    title: 'Hours',
  },
};
